/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { clsx } from 'clsx';
import React from 'react';

import { Breadcrumbs, BreadcrumbsProps } from '../Breadcrumbs/Breadcrumbs';
import styles from './PageContainerWithBreadcrumbs.module.scss';
import { useLocation } from 'react-router-dom';

type PageContainerWithBreadcrumbsProps = {
  breadcrumbsProps: BreadcrumbsProps;
  children: React.ReactNode;
  isBusy?: boolean; // just sets the cursor to wait
  overFlow?: boolean;
};

export function PageContainerWithBreadcrumbs({
  breadcrumbsProps,
  children,
  isBusy,
  overFlow,
}: PageContainerWithBreadcrumbsProps) {
  const isBrokenHeartsPage = useLocation().pathname === '/admin/analysis';
  return (
    <div className={clsx(styles.container, isBusy && styles.busy)}>
      <Breadcrumbs className={styles.breadcrumbs} {...breadcrumbsProps} />
      <div
        className={clsx(styles.inner, isBrokenHeartsPage && styles.forceScrollbar, overFlow && styles.overflowHidden)}
      >
        {children}
      </div>
    </div>
  );
}
